import React from "react"

export default function ChevronRight({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 5 8"
      fill="none"
    >
      <path
        d="M0.406201 0.578518L0 0.976907L3.02307 3.99998L0 7.02305L0.406201 7.42144L0.812401 7.82764L4.64006 3.99998L2.73404 2.08615C2.5726 1.92471 2.41377 1.76587 2.25754 1.60964C2.10131 1.45341 1.94377 1.29718 1.78494 1.14095C1.6261 0.984719 1.46857 0.828488 1.31234 0.672257C1.15611 0.516026 0.999878 0.359795 0.843647 0.203564L0.812401 0.172318C0.812401 0.172318 0.772042 0.211375 0.691322 0.289491C0.610603 0.367606 0.515562 0.463949 0.406201 0.578518Z"
        fill={color ? color : "var(--text-color)"}
      />
    </svg>
  )
}
